export default "__VITE_ASSET__0b2bb6dd__"